import axios from "axios";

export const api = axios.create({
    baseURL: "/api",
    headers: {
        "Content-type": "application/json",
        "Accept": "application/json, text/plain, */*, image/webp"
    }
});

export function setupAxiosInterceptors(setError: (error: any) => void) {
    api.interceptors.response.use(
        response => response, // Return the response if everything is fine
        error => {
            if (error.response) {
                const { status, data } = error.response;
                if (status === 404 || status === 500) {
                    setError({
                        status,
                        message: data.message,
                    });
                }
            }

            return Promise.reject(error);
        }
    );
}
